/* src/app/secure-image/secure-image.component.scss */
.chats .box {
  position: relative;
}
.chats .box .chat-msg-image .image-hover {
  display: none;
}
.chats .box:hover .chat-msg-image .image-hover {
  display: block;
}
/*# sourceMappingURL=secure-image.component.css.map */
